/* =========================================================
   JUMARY - Marca la tarjeta del producto destacado en el
   catálogo (por ahora: "HydroPet") para que jumary-catalog.css
   le agregue la insignia "★ Favorito".

   Si más adelante cambias de producto destacado, solo edita el
   texto dentro de las comillas de NOMBRE_PRODUCTO_DESTACADO.
========================================================= */
(function () {
  var NOMBRE_PRODUCTO_DESTACADO = 'HydroPet';

  function highlightFeaturedCard() {
    var links = document.querySelectorAll('a[href*="/products/"]');

    for (var i = 0; i < links.length; i++) {
      if (links[i].textContent.indexOf(NOMBRE_PRODUCTO_DESTACADO) !== -1) {
        var card =
          links[i].closest('li') ||
          links[i].closest('[class*="card" i]') ||
          links[i].parentElement;

        if (card) {
          card.classList.add('jumary-featured-card');
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', highlightFeaturedCard);
  } else {
    highlightFeaturedCard();
  }
})();